// extracted by mini-css-extract-plugin
export default {"createUserForm":"auth_createUserForm__Kzh0T","passwordDiv":"auth_passwordDiv__AkFJJ","indicator":"auth_indicator__-SLtW","loginLink":"auth_loginLink__HLjrl"};